import React, { useEffect, useState } from "react";
import { Button, TickCircleIcon, RefreshIcon, Pane } from "evergreen-ui";

function useExternalScript(src) {
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    if (!src) return;

    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (existing.getAttribute("data-loaded") === "true") {
        setStatus("ready");
      } else {
        const onLoad = () => {
          existing.setAttribute("data-loaded", "true");
          setStatus("ready");
        };
        existing.addEventListener("load", onLoad);
        return () => existing.removeEventListener("load", onLoad);
      }
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => {
      script.setAttribute("data-loaded", "true");
      setStatus("ready");
    };
    script.onerror = () => setStatus("error");

    document.body.appendChild(script);
    setStatus("loading");
  }, [src]);

  return status;
}

export default function SamedayLockerPlugin({ deliveryLocker, defaultLockerLocation, onPick }) {
  const [ready, setReady] = useState(false);
  const scriptStatus = useExternalScript("https://cdn.sameday.ro/locker-plugin/lockerpluginsdk.js");

  useEffect(() => {
    if (scriptStatus === "ready" && window.LockerPlugin && !ready) {
      window.LockerPlugin.init({
        clientId: "ae69bfd4-963c-4ef4-8d5d-81c870c5f183",
        countryCode: "RO",
        langCode: "ro",
        theme: "light",
        apiUsername: "kritAPI",
        filters: [{ showLockers: true }, { showPudos: true }],
      });

      const pluginInstance = window.LockerPlugin.getInstance();
      pluginInstance.subscribe((data) => {
        if (onPick) {
          onPick({
            id: data.lockerId,
            name: `${data.city}, ${data.county} - ${data.name}`,
            supportedPayment: data.supportedPayment,
          });
        }
        pluginInstance.close();
      });

      setReady(true);
    }
  }, [scriptStatus, ready, onPick]);

  const handleOpen = () => {
    const pluginInstance = window.LockerPlugin?.getInstance();
    pluginInstance?.open();
  };

  const hasSelection = deliveryLocker && deliveryLocker.id;

  return ready ? (<>
    {hasSelection ? <Pane>
        <span style={{ fontSize: 11, textTransform: "uppercase", opacity: 0.7 }}>{deliveryLocker.name}</span>
    </Pane> : null}
    <Button
        type="button"
      appearance={hasSelection ? "primary" : "default"}
      iconBefore={hasSelection ? TickCircleIcon : RefreshIcon}
      onClick={handleOpen}
    >
      <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
        <span style={{ fontSize: 14, fontWeight: 600 }}>
          {hasSelection ? null : "Alege un Easybox"}
        </span>
        {hasSelection && (
          <span style={{ fontSize: 11, textTransform: "uppercase", opacity: 0.7 }}>
            Schimba Easybox
          </span>
        )}
      </div>
    </Button>
          </>
  ) : null;
}